<template>
	<div class="hris-page">
	<div class="hris-page-inner">
		<div class="hris-page-header">
			<span class="hris-page-eyebrow">Employee Management</span>
			<h1 class="hris-page-title">Employer Names</h1>
			<p class="hris-page-subtitle">Manage the list of employer names used across employee records.</p>
		</div>
		<div class="row q-col-gutter-md">
			<div class="col-12 col-md-4">
				<div class="hris-form-section" style="margin-bottom: 0;">
					<div class="hris-form-section-title">Add Employer Name</div>
					<q-form ref="vForm" @submit="onSubmit" class="q-gutter-md">
						<q-input outlined dense color="green" v-model="employerName" label="Employer Name" :rules="[formRules.required]"></q-input>
						<q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
					</q-form>
				</div>
			</div>
			<div class="col-12 col-md-8">
				<div class="hris-panel" style="margin-bottom: 0;">
					<div class="hris-panel-title">Current Employer Names</div>
					<q-table flat :data="data" :columns="columns" row-key="id" :pagination.sync="pagination">
						<template v-slot:body="props">
							<q-tr :props="props" @click="selectedRow(props)" style="cursor: pointer;">
								<q-td key="name" :props="props">{{ props.row.employer_name }}</q-td>
								<q-td key="action" :props="props">
									<q-btn flat round dense class="hris-q-ghost" color="negative" @click="removeRow(props)">
										<i class="fas fa-trash"></i>
										<q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
											<strong>Remove</strong>
										</q-tooltip>
									</q-btn>
								</q-td>
							</q-tr>
						</template>
						<template v-slot:no-data="">
							<div class="hris-empty full-width">No employer names found.</div>
						</template>
					</q-table>
				</div>
			</div>
		</div>
	</div>

	<q-dialog v-model="spinner" persistent>
		<div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius);">
			<q-spinner color="green" size="40px"></q-spinner>
			<span>Please wait…</span>
		</div>
	</q-dialog>

	<q-dialog v-model="deleted" persistent>
		<div class="hris-modal" style="max-width: 420px;">
			<div class="hris-modal-body">
				<p style="margin: 0;">This employer name will be permanently deleted. Continue?</p>
			</div>
			<div class="hris-modal-footer">
				<q-btn unelevated class="hris-q-outline" label="Cancel" v-close-popup></q-btn>
				<q-btn unelevated color="negative" label="Continue" v-close-popup @click="deletionConfirmation"></q-btn>
			</div>
		</div>
	</q-dialog>
	</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';


export default {

	data () {
		return {
			counter:1,
			tempID:0,
			spinner:false,
			deleted:false,
			employerName:null,
			data:[],
			columns: [
			{ name: 'name', align: 'center', label: 'Name', field: 'name', sortable: true },
			{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
			],
			pagination: {
				rowsPerPage: 20
			},
		}
	},

	created(){
		this.displayData()
	},

	methods: {

		onSubmit : function(){
			this.spinner = true;
			let formData = new FormData();

			formData.append("name", this.titleCase(this.employerName));

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('create/employer/name', formData)
			.then((res) => {
				this.displayData()
				this.employerName = '',
				this.tempID = 0
				this.spinner = false;
				this.$refs.vForm.reset()
			});
		},

		displayData: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/employer/name`)
			.then((res) => {
				this.data = res.data.data;
				console.log(res.data)
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},

		selectedRow:function(obj){
			this.employerName = obj.row.name
			this.tempID = obj.row.id
		},

		removeRow:function(obj){
			this.deleted = true
			this.tempID = obj.row.id
		},

		deletionConfirmation:function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('remove/employer/name', formData)
			.then((res) => {
				this.tempID = 0
				this.displayData()
			});
		},

		titleCase(str) {
			var splitStr = str.toLowerCase().split(' ');
			for (var i = 0; i < splitStr.length; i++) {
				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
			}
			return splitStr.join(' '); 
		}

	}
}
</script>
<style>
</style>